export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="terms-page">
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA47E] mb-3">⌗ Legal</div>
      <h1 className="font-heading text-5xl tracking-tight">Terms of Service</h1>
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#595959] mt-4">Last updated · February 2026</p>

      <div className="prose prose-neutral mt-10 font-body text-[15px] text-[#333333] leading-relaxed space-y-6">
        <section>
          <h2 className="font-heading text-2xl">1. Acceptance</h2>
          <p>By creating an account on VoraStyle you agree to these Terms. If you don’t, please don’t use the service.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">2. Your content</h2>
          <p>You own the sets, clips, and text you publish. By posting, you grant VoraStyle a worldwide, non-exclusive license to display that content within the platform and in promotional contexts (with attribution).</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">3. Acceptable use</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>No clipping or uploading content you don’t have rights to.</li>
            <li>No harassment, hate, sexual content involving minors, or illegal material.</li>
            <li>No scraping or commercial reselling of the platform’s data without written permission.</li>
          </ul>
          <p>We may remove content or suspend accounts that violate these rules.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">4. Beta status</h2>
          <p>VoraStyle is currently in public beta. Features may change, break, or disappear. Please report bugs to <a href="mailto:Support@VoraStyle.com" className="underline underline-offset-4 decoration-[#9CA47E]">Support@VoraStyle.com</a>.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">5. Disclaimer</h2>
          <p>The service is provided “as is”. We are not liable for any indirect or consequential damages arising from its use.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">6. Contact</h2>
          <p>VoraStyle · Support@VoraStyle.com</p>
        </section>
      </div>
    </div>
  );
}
